<!--
 * @Author: CHY
 * @Date: 2023-08-25 11:23:25
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-08-26 12:02:59
 * @FilePath: \cheapFood\src\App.vue
-->
 
<template>
    <div id="app">
        <div v-cloak>
            <el-container direction="‘vertical’">
                <!-- Header  '@/assets/image/index/logo3.png' -->
                <!-- <header-page :logoUrl="logoUrl" /> -->
                <header-page :logoUrl="logoUrlEnd" />
                <!-- Tabs切换 -->
                <index-tabs :isQrCode="isQrCode" :tabsData="tabsData" @onClickTabs="onClickTabs($event)" :tabActive="tabActive" :contentWidth="contentWidth" />
                <!-- Main -->
                <el-main>
                    <div class="main-container" ref="mainContainer">
                        <div>
                            <transition name="fade-transform" mode="out-in">
                                <keep-alive>
                                    <router-view v-if="$route.meta.keepAlive" />
                                </keep-alive>
                            </transition>
                        </div>
                        <div>
                            <!-- :key="$route.fullPath"  如果想强制刷新，可以在根路由上为其分配一个唯一key。采用$route.fullpath作为其唯一key。这样vue就回认为内部路由每个都是不同的路由，在跳转时便会强制刷新组件-->
                            <transition name="fade-transform" mode="out-in">
                                <!-- :shareData="shareData" -->
                                <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath" ref="contentView" />
                            </transition>
                        </div>
                    </div>
                </el-main>
                <!-- Footer -->
                <el-footer height="auto">
                    <footer-page :footerData="footerData" :listKey="'relationFileList'" />
                </el-footer>
            </el-container>
        </div>
    </div>
</template>

<script>
    import qr_code from '@/assets/image/index/qr_code.png';
    import headerPage from "@/components/indexModule/header";
    import indexTabs from "@/components/indexModule/indexTabs";
    import footerPage from "@/components/indexModule/footerPage";
    export default {
        name: "App",
        data() {
            return {
                // logoUrlEnd:  require('@/assets/image/index/icon_logo@4.png'),
                // logoUrlEnd: require('@/assets/image/index/logo20201205.png'),
                logoUrlEnd: require('@/assets/image/index/logo20201219.png'),
                logoUrl: '',
                tabActive: -1,
                isQrCode: true,
                contentWidth: 1400, // 内容区域宽度，用于动态计算tab宽度
                observer: null, // MutationObserver实例
                resizeHandler: null, // resize事件处理器
                tabsData: [
                    // tab栏信息
                    {
                        name: "首页",
                        index: 0,
                        url: "/"
                    },
                    {
                        name: "法规制度",
                        index: 6,
                        url: "/statute"
                    },
                    {
                        name: "综合要闻",
                        index: 8,
                        url: "/exposure"
                    },
                    {
                        name: "采购需求",
                        index: 1,
                        url: "/tender"
                    },
                    {
                        name: "成交公告",
                        index: 2,
                        url: "/winning"
                    },
                    {
                        name: "食堂公开",
                        index: 3,
                        url: "/diningHall"
                    },
                    // {
                    //     name: "光盘行动",
                    //     index: 4,
                    //     url: "/cleanDishPages"
                    // },
                    // {
                    //     name: "风险食材",
                    //     index: 5,
                    //     url: "/riskfood"
                    // },
                    {
                        name: "违规预警",
                        index: 7,
                        url: "/volationWarning"
                    },
                    {
                        name: "服务中心",
                        index: 9,
                        url: "/servicetron"
                    },
                    {
                        name: "投诉监督",
                        index: 10,
                        url: "/complaint"
                    }
                ],
                // shareData: [], // 传到首页index的参数
                footerData: [{
                    title: '暂无友情链接',
                    relationFileList: [{
                        name: '暂无链接',
                        url: '/',
                    }]
                }] // 传到footer的参数
            };
        },
        components: {
            headerPage,
            indexTabs,
            footerPage
        },
        //监听属性 类似于data概念
        computed: {},
        //监控data中的数据变化
        watch: {
            $route: function(newVal, oldVal) {
                let indexpage = Number(newVal.query.index)
                let typePage = Number(newVal.query.type)
                this.tabsData.forEach((itm, idx) => {
                    if (newVal.path === itm.url) {
                        this.tabActive = itm.index;
                    }
                    if (newVal.path === '/merchants' || newVal.path === '/school' || newVal.path === '/successPage') {
                        this.tabActive = -1
                        this.isQrCode = false
                    } else {
                        this.isQrCode = true
                    }
                    if (typePage) {
                        this.tabActive = typePage;
                    }
                    // // 光盘行动、风险食材、法规制度、曝光台、服务中心、下载中心
                    // if (indexpage === 4 || indexpage === 6 || indexpage === 7 || indexpage === 8 || indexpage === 9 || indexpage === 10 || typePage === 4 || typePage === 6 || typePage === 7 || typePage === 8 || typePage === 9 || typePage === 10) {
                    //     this.tabActive = indexpage || typePage;
                    // }
                    // 系统公告
                    if (indexpage === 20) {
                        this.tabActive = 0;
                    }
                });
                // 路由变化后更新内容宽度
                // 延迟时间需要足够长，确保内容页已完全渲染
                setTimeout(() => {
                    this.updateContentWidth();
                }, 300);
            }
        },
        //方法集合
        methods: {
            // 浏览器检测
            getBrowserType() {
                var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
                // var browser = 'unknown';
                if (userAgent.indexOf("IE") != -1) {
                    browser = "IE";
                    confirm('您的浏览器版本过低，可能导致兼容问题')

                }
                // else if (userAgent.indexOf('Firefox') != -1) {
                //     alert('您使用的的Firefox浏览器')
                //     browser = "Firefox";
                // }
                // else if (userAgent.indexOf('OPR') != -1) {
                //     alert('您使用的的OPR浏览器')
                //     browser = "Opera";
                // }
                // else if (userAgent.indexOf('Chrome') != -1) {
                //     // alert('您使用的的Chrome浏览器')
                //     // browser = "Chrome";
                // }
                // else if (userAgent.indexOf('Safari') != -1) {
                //     alert('您使用的的Safari浏览器')
                //     browser = "Safari";
                // }
                else if (userAgent.indexOf('Trident') != -1) {
                    // alert('您使用的的IE-11浏览器')
                    confirm('您的浏览器版本过低，可能导致兼容问题')
                    // browser = 'IE 11';
                }
                // return browser;
            },
            // tabs切换
            onClickTabs(event) {
                let {
                    index,
                    url
                } = event
                this.tabActive = index;
                this.$router.push({
                    path: url,
                    query: {
                        index: index
                    }
                });
            },
            /**
             * 获取首页-底部链接2/标签条幅5 列表
             * @param type 类型（1-首页顶部轮播图，2-底部链接，3-上边条幅，4-下边条幅，5-标签条幅，不传查全部）
             */
            async getLiancanBannerList(type) {
                await this.$get(this.$api.getLiancanBannerList, {
                    type
                }).then(res => {
                    console.log(type == 2 ? "首页-底部链接列表" : type == 5 ? '5-logo标签条幅' : '>>>', res);
                    if (res.code === 200 && res.success && res.data.length > 0) {
                        if (type == 2) {
                            this.footerData = res.data
                        } else if (type == 5) {
                            let {
                                relationFileList
                            } = res.data[0]
                            if (relationFileList.length > 0) {
                                this.logoUrl = relationFileList[0].url
                            }
                        }
                    }
                })
            },
            // 更新内容区域宽度
            updateContentWidth() {
                this.$nextTick(() => {
                    let containerWidth = 1400; // 默认值
                    let foundPageIndex = false;
                    
                    // 优先检测当前内容页的 .page_index 元素的实际宽度
                    // 这样可以确保选项卡和内容页保持一致的宽度
                    const pageIndexElement = document.querySelector('.page_index');
                    if (pageIndexElement) {
                        const pageIndexStyle = window.getComputedStyle(pageIndexElement);
                        // 获取 .page_index 的实际渲染宽度（offsetWidth包括padding和border）
                        let pageIndexWidth = pageIndexElement.offsetWidth;
                        
                        // 如果offsetWidth无效，尝试其他方法
                        if (!pageIndexWidth || pageIndexWidth === 0) {
                            // 检查是否有明确的width样式
                            const widthValue = pageIndexStyle.width;
                            if (widthValue && widthValue !== 'auto' && widthValue !== '100%') {
                                pageIndexWidth = parseInt(widthValue);
                            } else {
                                // 使用clientWidth加上padding
                                pageIndexWidth = pageIndexElement.clientWidth;
                                const paddingLeft = parseInt(pageIndexStyle.paddingLeft) || 0;
                                const paddingRight = parseInt(pageIndexStyle.paddingRight) || 0;
                                pageIndexWidth = pageIndexWidth + paddingLeft + paddingRight;
                            }
                        }
                        
                        // 如果获取到了有效的宽度，使用它
                        if (pageIndexWidth && pageIndexWidth > 0) {
                            containerWidth = pageIndexWidth;
                            foundPageIndex = true;
                        }
                    }
                    
                    // 如果没找到 .page_index 或宽度无效，使用 main-container 的宽度
                    if (!foundPageIndex) {
                        if (this.$refs.mainContainer) {
                            const container = this.$refs.mainContainer;
                            const containerStyle = window.getComputedStyle(container);
                            
                            // 获取容器的总宽度（包括padding），这样选项卡可以和容器边缘对齐
                            // offsetWidth包括padding和border
                            containerWidth = container.offsetWidth;
                            
                            // 如果offsetWidth为0或无效，尝试其他方法
                            if (!containerWidth || containerWidth === 0) {
                                // 使用clientWidth加上padding
                                containerWidth = container.clientWidth;
                                const paddingLeft = parseInt(containerStyle.paddingLeft) || 20;
                                const paddingRight = parseInt(containerStyle.paddingRight) || 20;
                                containerWidth = containerWidth + paddingLeft + paddingRight;
                            }
                            
                            // 如果还是无效，使用max-width
                            if (!containerWidth || containerWidth === 0) {
                                const maxWidth = parseInt(containerStyle.maxWidth);
                                if (maxWidth > 0) {
                                    containerWidth = maxWidth;
                                } else {
                                    containerWidth = 1400; // 默认值
                                }
                            }
                        }
                    }
                    
                    // 确保宽度在合理范围内
                    if (containerWidth < 100 || containerWidth > 2000) {
                        containerWidth = 1400;
                    }
                    
                    // 更新宽度（优先使用内容页的实际宽度，确保选项卡和内容页对齐）
                    this.contentWidth = containerWidth;
                });
            }
        },
        //生命周期 - 创建完成（可以访问当前this实例）
        created() {
            this.getBrowserType()
            if (this.footerData.length < 2) {
                this.getLiancanBannerList(2)
            }
            if (!this.logoUrl) {
                this.getLiancanBannerList(5)
            }

        },
        //生命周期 - 挂载完成（可以访问DOM元素）
        mounted() {
            // 延迟执行，确保子组件已渲染
            setTimeout(() => {
                this.updateContentWidth();
            }, 500);
            // 监听窗口大小变化
            const resizeHandler = () => {
                setTimeout(() => {
                    this.updateContentWidth();
                }, 100);
            };
            window.addEventListener('resize', resizeHandler);
            this.resizeHandler = resizeHandler;
            
            // 使用MutationObserver监听DOM变化
            this.$nextTick(() => {
                if (this.$refs.mainContainer) {
                    this.observer = new MutationObserver(() => {
                        setTimeout(() => {
                            this.updateContentWidth();
                        }, 100);
                    });
                    this.observer.observe(this.$refs.mainContainer, {
                        childList: true,
                        subtree: true,
                        attributes: true,
                        attributeFilter: ['style', 'class']
                    });
                }
            });
        },
        beforeDestroy() {
            // 移除事件监听
            if (this.resizeHandler) {
                window.removeEventListener('resize', this.resizeHandler);
            }
            // 断开MutationObserver
            if (this.observer) {
                this.observer.disconnect();
            }
        },
        beforeCreate() {}, //生命周期 - 创建之前
        beforeMount() {}, //生命周期 - 挂载之前
        beforeUpdate() {}, //生命周期 - 更新之前
        updated() {}, //生命周期 - 更新之后
        beforeDestroy() {}, //生命周期 - 销毁之前
        destroyed() {}, //生命周期 - 销毁完成
        activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
    };
</script>

<style lang="less">
    .footerPopper {
        a {
            &:link {
                color: inherit;
            }

            &:visited {
                color: inherit;
            }
        }
    }
</style>

<style lang="less" scoped>
    #app {
        font-family: Helvetica, sans-serif;
        text-align: center;
        min-width: 1400px;
        background-color: #f5f7f9;
    }

    .el-container {
        height: 100%;
        padding: 0;
        margin: 0;
        width: 100%;
    }

    .el-main {
        padding: 0;
        background-color: #f5f7f9;
    }

    .main-container {
        width: 100%;
        margin: 0 auto;
        min-height: 100%;
        position: relative;
        z-index: 1;
        padding: 0 20px;
        box-sizing: border-box;
    }

    .el-footer {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        background-color: @back;

        .text_address,
        .copyright {
            font-size: 16px;
            color: rgba(255, 255, 255, 1);
        }

        .text_address {
            margin-bottom: 20px;
        }
    }

    /* 
    enter-active 定义进入过渡的结束状态
    leave-active 定义离开过渡的结束状态
    */
    .fade-transform-leave-active,
    .fade-transform-enter-active {
        transition: all 0.3s;
    }

    /* 
    enter定义进入过渡的开始状态
    */
    .fade-transform-enter {
        opacity: 0;
        transform: translateX(-30px);
    }

    /* 
    leave-to离场动画结束后的状态
    */
    .fade-transform-leave-to {
        opacity: 0;
        transform: translateX(30px);
    }
</style>


// WEBPACK FOOTER //
// src/App.vue